import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TeleconsultPaymentDetailPopupComponent } from './teleconsult-payment-detail-popup.component';
import { AngularMaterialModule } from '../../angular-material';

@NgModule({
  declarations: [TeleconsultPaymentDetailPopupComponent],
  imports: [CommonModule, AngularMaterialModule],
  exports: [TeleconsultPaymentDetailPopupComponent],
})
export class TeleconsultPaymentDetailPopupModule {}
